module.exports = __webpack_public_path__ + "img/cg_sugar_flower.707fdff2.jpg";